import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  NetworkGrid,
  useGetNetworkCounts
} from "../../../common/dynamicanalysis";
import { Title } from "../../../../../../components/dynamicanalysis";
import LoadingAndErrorBoundary from "../../../../../commons/LoadingAndErrorBoundary";
import { LoadingIndicator } from "../../../../../../components";
import { JoeNetworkCount, JoeNetworks } from "../../../../@types";
import { items } from "./items";

const Network = () => {
  const { hash, uploadId } = useParams();

  const { data } = useGetNetworkCounts<JoeNetworkCount>(hash, "joe", uploadId);

  return (
    <>
      <Title headingLevel="h1" title="Network Analysis" />
      <Tabs defaultActiveKey={Object.keys(items)[0]} mountOnEnter unmountOnExit>
        {Object.entries(items).map(([key, { title, schema, errorMsg }]) => (
          <Tab
            key={key}
            eventKey={key}
            title={`${title} (${
              (data && data[key as keyof JoeNetworkCount]) || 0
            })`}
          >
            <LoadingAndErrorBoundary
              errorFallback={() => <div>{errorMsg}</div>}
              suspenseFallback={
                <LoadingIndicator data-testid={`${key}-loading-indicator`} />
              }
            >
              <NetworkGrid<JoeNetworks>
                schema={schema}
                type={key as JoeNetworks}
                analysis="joe"
              />
            </LoadingAndErrorBoundary>
          </Tab>
        ))}
      </Tabs>
    </>
  );
};

export default Network;
